import { FormProvider, useForm } from 'react-hook-form';
import * as React from 'react';
import ControlledInput from '../../components/ControlledInput';
import BtnFilled from '../../components/BtnFilled';
import { ERROR_TEXT } from '../../constants';
import { getUserApi, logout, updateUserEmail } from '../../api/api';
import Modal from '../../components/Modal';
import { useUserStore } from '../../stores';
import { toast } from 'react-toastify';
import { useState } from 'react';
import useThrottle from '../../utils/use-throttle';
import TitleWithIcon from '../../components/TitleWithIcon';
import { validRussianEmail } from '../../regex';
import EditIcon from '@mui/icons-material/Edit';

const EditEmailForm = () => {
  const { user, setAuthorized, setUser } = useUserStore();
  const methods = useForm({
    mode: 'onChange',
    defaultValues: { email: user?.email },
  });
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = async () => {
    toast.success('На вашу почту была отправлена ссылка. Для подтверждения смены почты перейдите по ней');
    setShowModal(false);
    await logout();
    await getUserApi(
      (data) => {
        setUser(data);
        setAuthorized(true);
      },
      (err) => {
        setAuthorized(false);
      }
    );
  };

  const handleError = (err) => {
    toast.error(err?.error || 'Произошла ошибка при обновлении');
  };

  const handleSubmit = useThrottle(async (data) => {
    const formData = { ...data, redirect_link: `${process.env.REACT_APP_REDIRECT_LINK}verify` };
    await updateUserEmail(formData, handleSuccess, handleError);
  }, 500);

  return (
    <>
      <TitleWithIcon
        Icon={EditIcon}
        title={'Обновить почту'}
        handler={() => setShowModal(true)}
        buttonStyle={'p-1'}
        titleStyle={'text-xl'}
        containerStyle={'justify-between gap-2 px-4'}
      />
      <Modal showSave={false} showModal={showModal} setShowModal={setShowModal} title={'Обновить почту'}>
        <FormProvider {...methods}>
          <ControlledInput
            onKeyDown={(e) => {
              if (e.key === 'Enter') e.preventDefault();
            }}
            name={'email'}
            rules={{
              required: ERROR_TEXT.REQUIRED,
              pattern: {
                value: validRussianEmail,
                message: 'Разрешена только почта с русским доменом',
              },
            }}
          />
          <BtnFilled
            disabled={!methods.formState.isValid || !methods.formState.isDirty}
            btnCb={methods.handleSubmit(handleSubmit)}
            className={'flex justify-center max-w-[220px] m-auto'}
            color={'bg-orange-500'}
            title="Обновить"
          />
        </FormProvider>
      </Modal>
    </>
  );
};

export default EditEmailForm;
